import { errorHandler } from "utils/middlewares/errorHandler";
import API_CONFIG from "../config/axiosConfig";
import { handleResponse } from "../config/axiosUtils";
import axios from "axios";

export async function signUpRequest(method, data) {
  const url = `${API_CONFIG.baseUrl}/company/onboardings`;

  try {
    const response = await axios({
      method,
      url,
      headers: {
        ...API_CONFIG.headers,
      },
      data: JSON.stringify(data),
    });

    return handleResponse(response);
  } catch (error) {
    errorHandler(error?.response);
    return error;
  }
}
